import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  currencyActionId,
  downloadReport,
  hsncodeActionId,
  sessionExpireMessage,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import moment from "moment";
import Header from "../../../common_components/Header";
import {
  debit_note_detail_order_action,
  debit_note_detail_action,
  debit_note_add_action,
  download_debitNote_action,
} from "../../../actions/accounts_action/account_debit_note_action";

class AccountDebitNoteAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      userId: "",
      OrderID: "",
      ClientID: "",
      DebitNoteID: "",
      DebitNoteNo: "",
      DebitNoteDate: "",
      CompanyName: "",
      Address: "",
      GSTNo: "",
      CurrencyID: "",
      Currency: "",
      OrderNo: "",
      Remark: "",
      selectedHSNCode: "",
      PrimaryEmailID: "",
      currencyFillList: [],
      hsnFillList: [],
      udtList: [],
      udtDetail: {
        SrNo: "",
        Narration: "",
        HSNCode: "",
        GST: "",
        Price: "",
        Quantity: "",
        Amount: "",
      },
      editedRowIndex: null,
      editedRowData: {},
      showNewRow: false,
      debitNoteData: [],
      RoleID:"",
    };
    this.backDebitNote = this.backDebitNote.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getDetailsFromOrder = this.getDetailsFromOrder.bind(this);
    this.getDetailsFromEdit = this.getDetailsFromEdit.bind(this);
  }
  componentDidMount() {
    const { userId } = this.state;
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
    this.setState({
      OrderID:
        this.props.location.state != null &&
        this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      PrimaryEmailID:
        this.props.location.state != null &&
        this.props.location.state.PrimaryEmailID != null
          ? this.props.location.state.PrimaryEmailID
          : "",
          RoleID:
        this.props.location.state != null &&
        this.props.location.state.RoleID != null
          ? this.props.location.state.RoleID
          : "",
    });
    console.log("propsState", this.props.location.state);
    const OrderID = this.props.location.state?.OrderID || "";
    const DebitNoteID = this.props.location.state?.DebitNoteID || "";
    console.log("OrderID & DebitNoteID", OrderID, DebitNoteID);
    if (OrderID) {
      console.log("order",OrderID)
      this.setState({ OrderID }, () => {
        this.getDetailsFromOrder(OrderID);
      });
    }else
    if (DebitNoteID) {
      console.log("debit")

      this.setState({ DebitNoteID }, () => {
        this.getDetailsFromEdit();
      });
    }
    this.getFillList(currencyActionId, userId, "", "");
    this.getFillList(hsncodeActionId, userId, "", "");
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        console.log(data, "FillList");
        if (data.error != 1) {
          if (value == currencyActionId) {
            this.setState({ currencyFillList: data.data, isLoading: false });
          }
          if (value == hsncodeActionId) {
            this.setState({ hsnFillList: data.data, isLoading: false });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  backDebitNote() {
    this.props.navigate("/debitNoteList");
  }
  backToOrderEdit(OrderID, ClientID) {
    this.props.navigate("/orderEdit", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
      },
    });
  }
  handleAddRowUDT() {
    const { udtList, udtDetail } = this.state;
    if(udtDetail.Narration==""){
      toast.error("Please Enter Narration",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.HSNCode==""||udtDetail.HSNCode==null){
      toast.error("Please Select HSN Code",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.Price==""){
      toast.error("Please Enter Price",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(udtDetail.Quantity==""){
      toast.error("Please Enter Quantity",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else{
      const newRow = { ...udtDetail, SrNo: udtList.length + 1 };
      this.setState({
        udtList: [...udtList, newRow],
        udtDetail: {
          SrNo: udtList.length + 2,
          Narration: "",
          HSNCode: "",
          GST: "",
          Price: "",
          Quantity: "",
          Amount: "",
        },
        showNewRow: false,
      });
    }
  }

  toggleNewRow() {
    this.setState((prevState) => ({
      showNewRow: !prevState.showNewRow,
    }));
  }
  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.handleAddRowUDT();
    }
  }
  handleEditRow(index, data) {
    this.setState({
      editedRowIndex: index,
      editedRowData: { ...data },
    });
  }
  handleRowEditFieldChange(index, field, value) {
    const editedDataCopy = { ...this.state.editedRowData };
    editedDataCopy[field] = value;

    // Check if the edited field is "Price" or "Quantity" and recalculate "Amount"
    if (field === "Price" || field === "Quantity") {
      editedDataCopy.Amount = editedDataCopy.Price * editedDataCopy.Quantity;
    }

    this.setState({ editedRowData: editedDataCopy });
  }

  saveEditedRow(index) {
    const { udtList, editedRowData } = this.state;
    if(editedRowData.Narration==""){
      toast.error("Please Enter Narration",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.HSNCode==""||editedRowData.HSNCode==null){
      toast.error("Please Select HSN Code",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.Price==""){
      toast.error("Please Enter Price",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else if(editedRowData.Quantity==""){
      toast.error("Please Enter Quantity",{
        position:"top-center",
        autoClose: 2000,
        hideProgressBar: true,
        theme:"colored"
      })
    }else{
    const updatedList = [...udtList];
    updatedList[index] = editedRowData;
    this.setState({
      udtList: updatedList,
      editedRowIndex: null,
      editedRowData: {},
    });
  }
  }
  cancelEditRow() {
    this.setState({
      editedRowIndex: null,
      editedRowData: {},
    });
  }
  handleDeleteRow(index) {
    const { udtList } = this.state;
    const updatedList = [...udtList];
    updatedList.splice(index, 1); // Remove the row at the specified index
    this.setState({
      udtList: updatedList,
    });
  }
  
  getDetailsFromOrder() {
    const { userId } = this.state;
    const OrderID = this.props.location.state.OrderID;
    console.log(userId, OrderID, "const console");
    if (OrderID) {
      this.props
        .debit_note_detail_order_action(userId, OrderID)
        .then((data) => {
          console.log("credit from order details-----", data);
          if (data.error !== 1) {
            this.setState({
              DebitNoteID: data.data[0]["DebitNoteID"],
              DebitNoteNo: data.data[0]["DebitNoteNo"],
              DebitNoteDate: moment(data.data[0]["DebitNoteDate"]).format('DD-MM-YYYY'),
              CompanyName: data.data[0]["CompanyName"],
              Address: data.data[0]["Address"],
              GSTNo: data.data[0]["GSTNo"],
              CurrencyID: data.data[0]["CurrencyID"],
              Currency: data.data[0]["Currency"],
              OrderNo: data.data[0]["OrderNo"],
              ClientID: data.data[0]["ClientID"],
            });
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.data, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      toast.error("details not found", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  }
  getDetailsFromEdit() {
    const { userId } = this.state;
    const DebitNoteID = this.props.location.state.DebitNoteID;

    if (DebitNoteID) {
      this.props
        .debit_note_detail_action(userId, DebitNoteID)
        .then((response) => {
          if (response.error !== 1) {
            const data = response.data; // Extract data from the API response

            this.setState({
              DebitNoteID: data[0][0]["DebitNoteID"],
              DebitNoteNo: data[0][0]["DebitNoteNo"],
              DebitNoteDate: moment(data[0][0]["DebitNoteDate"]).format('DD-MM-YYYY'),
              CompanyName: data[0][0]["CompanyName"],
              Address: data[0][0]["Address"],
              GSTNo: data[0][0]["GSTNo"],
              CurrencyID: data[0][0]["CurrencyID"],
              Currency: data[0][0]["Currency"],
              OrderNo: data[0][0]["OrderNo"],
              ClientID: data[0][0]["ClientID"],
              Remark: data[0][0]["Remark"],
              OrderID: data[0][0]["OrderID"],
              udtList: data[1], // Assign the array from data[1] to amountArr
            });
            console.log("1st index", data[1]);
          } else {
            if(response.msg == sessionExpireMessage || response.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(response.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(response.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      toast.error("Details for edit not found", {
        position:"top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  }
  downloadDebitNote(DebitNoteID, DebitNoteNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (DebitNoteID) {
      console.log(DebitNoteID, DebitNoteNo);
      const formattedDebitNoteNo = DebitNoteNo.replace(/[\/-]/g, "_");
      this.props
        .download_debitNote_action(userId, DebitNoteID, formattedDebitNoteNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if(downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false });
            toast.error(downloadData.msg,{
              position:"top-center",
              autoClose:1000,
              theme:"colored",hideProgressBar:true
            });
          }}
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: DebitNoteID not found.",{
        position:"top-center",
        autoClose:1000,
        theme:"colored",hideProgressBar:true
      });
    }
  }
  handleHSNCodeChange = (index, selectedHSNCode) => {
    // Update the selected HSNCode in the state
    this.setState({
      selectedHSNCode,
    });
  };

  clearFields() {}
    handleSubmit() {
    const {
      userId,
      DebitNoteID,
      DebitNoteNo,
      DebitNoteDate,
      OrderNo,
      CompanyName,
      Address,
      GSTNo,
      CurrencyID,
      Remark,
      udtList,
      OrderID,
      ClientID,PrimaryEmailID
    } = this.state;
    console.log(
      "testing------->",
      userId,
      DebitNoteID,
      DebitNoteNo,
      DebitNoteDate,
      OrderNo,
      CompanyName,
      Address,
      GSTNo,
      CurrencyID,
      Remark,
      OrderID,
      ClientID
    );
    if(udtList.length===0){
      toast.error('Kindly Fill Debit Note',{
        position:"top-center",
        theme:"colored",
        autoClose:2000,
        hideProgressBar: true,
      })
    }else{

   
    this.setState({ isLoading: true });
    this.props
      .debit_note_add_action(
        userId,
        DebitNoteID,
        DebitNoteNo,
        DebitNoteDate,
        OrderNo,
        CompanyName,
        Address,
        GSTNo,
        CurrencyID,
        Remark,
        udtList,
        OrderID,
        ClientID,PrimaryEmailID
      )
      .then((data) => {
        console.log(data, "update");
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Data Updated Successfully", {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.props.navigate("/debitNoteList");
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          this.setState({ isLoading: false });
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    }
  }
  render() {
    const {
      isLoading,
      isAccordionExpanded,
      OrderID,
      OrderNo,
      ClientID,
      DebitNoteDate,
      DebitNoteNo,DebitNoteID,
      CompanyName,
      Address,
      GSTNo,
      Currency,
      CurrencyID,
      currencyFillList,
      SrNo,
      Narration,
      HSNCode,
      GST,
      Price,
      Quantity,
      Amount,
      udtList,
      udtDetail,
      editedRowIndex,
      editedRowData,
      hsnFillList,
      selectedHSNCode,
      showNewRow,
      Remark,
    } = this.state;
    const udtListWithAmount = udtList.map((data) => ({
      ...data,
      Amount: data.Price * data.Quantity,
    }));
    // Calculate the "Total Amount" by summing the "Amount" from each row
    const totalAmount = udtList.reduce(
      (total, row) => total + parseFloat(row.Amount || 0),
      0
    );

    // Calculate the "GST Amount" by summing the product of "GST" and "Amount" from each row
    const gstAmount = udtList.reduce(
      (total, row) =>
        total + (parseFloat(row.GST || 0) * parseFloat(row.Amount || 0)) / 100,
      0
    );
    const debitIDorOrderID =
      this.props.location.state.DebitNoteID ||
      this.props.location.state.OrderID;
      const isEdit=this.props.location.state.isEdit||0
    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              <Header data={[13]} />

              <section style={{ marginTop: "115px" }}>
                <div class="container-fluid">
                  <div class="page-header">
                    <h4 class="page-title">{isEdit==1?"Edit":"Add"} Debit Note</h4>
                    {isEdit==1?(<div className="row">
                      <div class="mx-2">
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            this.downloadDebitNote(
                              debitIDorOrderID,
                              DebitNoteNo
                            )
                          }
                          class="btn btn-success btn-sm fs-12"
                        >
                          <i class="fa fa-download"></i> Download
                        </a>
                      </div>
                      <div class="mx-2">
                        <a
                          href="javascript:void(0);"
                          onClick={() =>
                            this.downloadDebitNote(
                              debitIDorOrderID,
                              DebitNoteNo
                            )
                          }
                          class="btn btn-warning btn-sm fs-12"
                        >
                          <i class="fa fa-envelope"></i> Email
                        </a>
                      </div>
                    </div>):<></>}
                  </div>
                  <div class="card Service_fields">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Debit Note No</label>
                            {console.log("from input", DebitNoteNo)}
                            <input
                              type="text"
                              class="form-control search_form_control"
                              value={DebitNoteNo}
                              onChange={(e) =>
                                this.setState({ DebitNoteNo: e.target.value })
                              }
                              disabled 
                              placeholder="Enter Debit Note No"
                            />
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Debit Note Date</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Debit Note Date"
                              value={DebitNoteDate}
                              disabled 
                              onChange={(e) =>
                                this.setState({ DebitNoteDate: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-8">
                          <div class="row">
                            <div class="col-md-8"></div>
                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Order Reference</label>
                                <input
                                  type="text"
                                  class="form-control search_form_control"
                                  placeholder="Order Reference"
                                  value={OrderNo}
                                  disabled
                                  onChange={(e) =>
                                    this.setState({ OrderNo: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Company</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Company"
                              value={CompanyName}
                              disabled 
                              onChange={(e) =>
                                this.setState({ CompanyName: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Company Address</label>
                            <input
                              type="text"
                              class="form-control search_form_control"
                              placeholder="Enter Company Address"
                              value={Address}
                              disabled 
                              onChange={(e) =>
                                this.setState({ Address: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>GST No</label>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter GST No"
                              disabled
                              value={GSTNo}
                              onChange={(e) =>
                                this.setState({ GSTNo: e.target.value })
                              }
                            />
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-group">
                            <label>Currency (USD / INR)</label>
                            <select
                              class="form-control"
                              value={CurrencyID}
                              disabled 
                              onChange={(e) => {
                                const selectedCurrency = e.target.value;
                                this.setState({ CurrencyID: selectedCurrency });
                              }}
                            >
                              <option>--SELECT--</option>
                              {currencyFillList.length > 0 &&
                                currencyFillList.map((data) => (
                                  <option key={data.ID} value={data.ID}>
                                    {data.Currency}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="custom_table">
                            <div class="hack1 card mb-3">
                              <div
                                class="hack2 card-body"
                                style={{ background: "#f8f8f8" }}
                              >
                                <table
                                  class="table table-bordered table-striped"
                                  id="dashboard-table"
                                >
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>Narration</th>
                                      <th>HSN Code</th>
                                      <th>GST %</th>
                                      <th>Price</th>
                                      <th>Quantity</th>
                                      <th>Amount</th>
                                      {this.props.location.state.RoleID === 3?null:
                                      <th
                                        class="text-right"
                                        style={{ width: "8%" }}
                                      >
                                        Action
                                      </th>}
                                    </tr>
                                  </thead>
                                  <tbody id="myTable">
                                    {udtListWithAmount.length > 0 ? (
                                      udtListWithAmount.map((data, index) => (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Narration
                                                    : data.Narration
                                                }
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Narration",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              data.Narration
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <select
                                                className="form-control"
                                                name="HSNCode"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.HSNCode
                                                    : data.HSNCode
                                                }
                                                onChange={(e) =>
                                                  this.handleHSNCodeChange(
                                                    index,
                                                    e.target.value
                                                  )
                                                }
                                              >
                                                <option value="">
                                                  --Select--
                                                </option>
                                                {hsnFillList.map((data) => (
                                                  <option
                                                    key={data.HSNCode}
                                                    value={data.HSNCode}
                                                  >
                                                    {data.HSNCode}
                                                  </option>
                                                ))}
                                              </select>
                                            ) : (
                                              data.HSNCode
                                            )}
                                          </td>

                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={`${editedRowData.GST}%`}
                                                disabled
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "GST",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              // Display the selected GST based on the state
                                              `${
                                                hsnFillList.find(
                                                  (item) =>
                                                    item.HSNCode ===
                                                    this.state.selectedHSNCode
                                                )?.GST || data.GST
                                              }%`
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Price
                                                    : data.Price
                                                }
                                                onChange={(e) =>{
                                                  const value = e.target.value;
                                                 
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                    this.handleRowEditFieldChange(
                                                      index,
                                                      "Price",
                                                      numericValue
                                                    )
                                                  } 
                                                }
                                              />
                                            ) : (
                                              data.Price?.toLocaleString(
                                                "en-IN"
                                              )
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  editedRowIndex === index
                                                    ? editedRowData.Quantity
                                                    : data.Quantity
                                                }
                                                onChange={(e) =>{
                                                  const value = e.target.value;
                                               
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Quantity",
                                                    numericValue
                                                  )}}
                                              />
                                            ) : (
                                              data.Quantity
                                            )}
                                          </td>
                                          <td>
                                            {editedRowIndex === index ? (
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={editedRowData.Amount}
                                                disabled={true}
                                                onChange={(e) =>
                                                  this.handleRowEditFieldChange(
                                                    index,
                                                    "Amount",
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            ) : (
                                              data.Amount?.toLocaleString(
                                                "en-IN"
                                              )
                                            )}
                                          </td>
                                          {this.props.location.state.RoleID === 3?null:
                                          <td className="text-right">
                                            {editedRowIndex === index ? (
                                              <>
                                                <a
                                                  title="Save"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.saveEditedRow(index)
                                                  }
                                                >
                                                  <i className="fa fa-save action_btn_table" />
                                                </a>
                                                <a
                                                  title="Cancel"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.cancelEditRow()
                                                  }
                                                >
                                                  <i className="fa fa-times action_btn_table" />
                                                </a>
                                              </>
                                            ) : (
                                              <>
                                                <a
                                                  title="Edit"
                                                  className="btn btn-sm padding_0"
                                                  onClick={() =>
                                                    this.handleEditRow(
                                                      index,
                                                      data
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-edit action_btn_table" />
                                                </a>
                                                <a
                                                  title="Delete"
                                                  className="btn btn-sm delete_record padding_0"
                                                  onClick={() =>
                                                    this.handleDeleteRow(index)
                                                  }
                                                >
                                                  <i className="fa fa-trash action_btn_table" />
                                                </a>
                                              </>
                                            )}
                                          </td>}
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="8">No data available.</td>
                                      </tr>
                                    )}
                                    {showNewRow && (
                                      <tr>
                                        <td></td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Narration}
                                            onChange={(e) =>
                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  Narration: e.target.value,
                                                },
                                              })
                                            }
                                          />
                                        </td>
                                        <td>
                                          <select
                                            className="form-control col-md-12"
                                            name="HSNCode"
                                            value={udtDetail.HSNCode}
                                            onChange={(e) => {
                                              const selectedHSNCode =
                                                e.target.value;
                                              const selectedGST =
                                                hsnFillList.find(
                                                  (item) =>
                                                    item.HSNCode ===
                                                    selectedHSNCode
                                                )?.GST || "";

                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  HSNCode: selectedHSNCode,
                                                  GST: selectedGST,
                                                },
                                              });
                                            }}
                                          >
                                            <option value="">--Select--</option>
                                            {hsnFillList.map((data) => (
                                              <option
                                                key={data.HSNCode}
                                                value={data.HSNCode}
                                              >
                                                {data.HSNCode}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={`${udtDetail.GST}%`}
                                            disabled
                                          />
                                        </td>

                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Price?.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                          
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                                this.setState({
                                                  udtDetail: {
                                                    ...udtDetail,
                                                    Price: numericValue,
                                                    Amount:
                                                      numericValue *
                                                      udtDetail.Quantity, // Calculate "Amount"
                                                  },
                                                })
                                              }
                                            }
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Quantity}
                                            onChange={(e) =>{
                                              const value = e.target.value;
                                              
  const numericValue = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                              this.setState({
                                                udtDetail: {
                                                  ...udtDetail,
                                                  Quantity: numericValue,
                                                  Amount:
                                                    udtDetail.Price *
                                                    numericValue, // Calculate "Amount"
                                                },
                                              })}}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={udtDetail.Amount?.toLocaleString(
                                              "en-IN"
                                            )}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="text-right">
                                          <button
                                            className="btn btn-primary btn-md"
                                            onClick={() =>
                                              this.handleAddRowUDT()
                                            }
                                          >
                                            Add
                                          </button>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                                {this.props.location.state.RoleID === 3?null:
                                <div>
                                  <a
                                    href="javascript:void(0);"
                                    class="btn btn-primary btn-sm create_btn add_new_table_btn"
                                    style={{ width: "auto" }}
                                    onClick={() => this.toggleNewRow()}
                                  >
                                    <span class="hidden-xs">
                                      {showNewRow ? "Cancel" : "Add"}
                                    </span>
                                  </a>
                                </div>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="custom_table">
                          <div class="hack1 card mb-3">
                            <table
                              class="table table-bordered table-striped"
                              id="dashboard-table"
                            >
                              <tbody id="myTable">
                                <tr>
                                  <td>Total Amount</td>
                                  <td>{totalAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                  <td>GST Amount</td>
                                  <td>{gstAmount.toFixed(2)}</td>
                                </tr>
                                <tr>
                                  <td>Total Payable</td>
                                  <td>
                                    {(totalAmount + gstAmount).toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Remark</label>
                            <textarea
                              class="form-control"
                              rows="3"
                              placeholder="Type here..."
                              value={Remark}
                              disabled={this.props.location.state.RoleID === 3}
                              onChange={(e) =>
                                this.setState({ Remark: e.target.value })
                              }
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                      {this.props.location.state.RoleID === 3?null:
                        <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={this.handleSubmit}
                            class="btn save_btn"
                          >
                            {DebitNoteID?"Update":"Save"}
                          </a>
                        </div>
  }
                        <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.backDebitNote()}
                            class="btn back_btn"
                          >
                            Back
                          </a>
                        </div>
                        {/* <div class="mx-2">
                          <a
                            href="javascript:void(0);"
                            onClick={() => this.backDebitNote()}
                            class="btn back_btn"
                          >
                            Order Detail
                          </a>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <ToastContainer />
            </main>
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    debit_note_detail_order_action,
    debit_note_detail_action,
    debit_note_add_action,
    download_debitNote_action,
  })(AccountDebitNoteAU)
);
